// extracted by mini-css-extract-plugin
export default {"waiting_Info":"ShowFish_waiting_Info__fdypO"};